import { request } from '@/axios';

interface UpdatePhoneNumber {
  phoneNumber: string;
  code: string;
}
export function updatePhoneNumber(data: UpdatePhoneNumber) {
  return request({
    api: '/api/getUserInfo',
    method: 'post',
    data
  });
}

// 修改用户头像
export function updateAvatar(data: {
  avatar: string;
}) {
  return request({
    api: '/api/user/updateProfilePhoto',
    method: 'post',
    data
  });
}

// 修改用户昵称
export function updateNikename(data: {
  nickname: string;
}) {
  return request({
    api: '/api/user/updateNikename',
    method: 'post',
    data
  });
}

// 修改密码
export function restPassword(data: {
  email: string;
  account: string;
  originPassword?: string;
  password: string;
}) {
  return request({
    api: '/user/restPassword',
    method: 'post',
    data
  });
}

// 自定义存取用户相关的值
export function setUserCustomStorage(data: {
  key: string;
  value: string;
}) {
  return request({
    api: '/api/customStorage/add',
    method: 'post',
    data
  });
}

// 自定义存取用户相关的值
export function getUserCustomStorage(key: string) {
  return request<any>({
    api: '/api/customStorage/get',
    method: 'get',
    params: {
      key
    }
  });
}

// 兑换码兑换会员
export function getBindExchangeCode(data: {
  exchangeCode: string;
}) {
  return request<any>({
    api: '/api/user/bindExchangeCode',
    method: 'post',
    data
  });
}

// 获取用户标签
export function getUserTag(data: {
  userId: string;
}) {
  return request<any>({
    api: '/api/userTag/getUserTag',
    method: 'post',
    data,
    notToast: true,
  });
}

// 更新用户标签
export function updateUserTag(data: {
  userId: string;
  artworkLabelIdList: number[];
}) {
  return request<any>({
    api: '/api/userTag/updateUserTag',
    method: 'post',
    data,
  });
}

/**
 * 客户端触发站内消息通知
 */

export interface ClientNotifyMessageParams {
  /** clientId */
  clientId: string;
  /** 消息类型 1:3D模型高清下载 */
  taskType: number;
  /** 任务执行时长(单位:秒)，可为空 */
  taskTime?: number;
  /** 消息类型：NotifyMessageTypeEnums 1-默认消息，2-成功消息，3-失败消息 */
  type: number;
  /** 消息内容，可为空 */
  content?: string;
  /** 是否弹窗：0-否，1-是 */
  pop: number;
  /** 附带信息：json字符串，用于具体弹窗信息 */
  info?: string;
}

/**
 * 客户端触发站内消息通知
 * @param data 通知消息参数
 */
export function clientNotifyMessage(data: ClientNotifyMessageParams) {
  return request<any>({
    api: '/api/common/clientNotifyMessage',
    method: 'post',
    data
  });
}

// 检测原手机+验证码
export function checkOriginAccount(data: {
  account: string;
  code: string;
}) {
  return request({
    api: '/api/user/checkOriginAccount',
    method: 'post',
    data
  });
}

// 绑定手机号
export function bandingUserPhone(data: {
  account: string;
  code: string;
  uniqueId: string;
}) {
  return request<{
    token: string;
  }>({
    api: '/api/user/bandingUserPhone',
    method: 'post',
    data
  });
}

// 手机号换绑
export function changeUserAccount(data: {
  newAccount: string;
  newCode: string;
  originAccount?: string;
  originCode?: string;
  uniqueId: string;
}) {
  return request<{
    token: string;
  }>({
    api: '/api/user/changeUserAccount',
    method: 'post',
    data
  });
}

// 绑定、解绑微信获取二维码
export function getUpdateWechatBindQRCode(data: {
  event: 'banding' | 'unBanding'
}) {
  return request({
    api: '/api/wechatOfficialAccount/getQrCodeByOther',
    method: 'post',
    data
  });
}

// 查询绑定、解绑微信获取二维码状态
export function getUpdateWechatBindQRCodeStatus(data: {
  ticket: string;
  uniqueId: string;
}) {
  return request({
    api: '/api/wechatOfficialAccount/getBandingResultByCircle',
    method: 'post',
    data,
    notToast: true,
  });
}

// 执行微信绑定
export function bandingWechat(data: {
  openId: string;
  unionId: string;
  uniqueId: string;
}) {
  return request({
    api: '/api/wechatOfficialAccount/bandingWechat',
    method: 'post',
    data,
  });
}

// 执行微信解绑
export function unBandingWechat(data: {
  openId: string;
  unionId: string;
  uniqueId: string;
}) {
  return request({
    api: '/api/wechatOfficialAccount/unBandingWechat',
    method: 'post',
    data,
  });
}

// 检测原邮箱+验证码
export function checkOriginEmail(data: {
  email: string;
  code: string;
}) {
  return request({
    api: '/api/user/checkOriginAccount',
    method: 'post',
    data
  });
}

// 绑定邮箱
export function bandingUserEmail(data: {
  code: string;
  email: string;
  password?: string;
  uniqueId: string;
}) {
  return request<{
    token: string;
  }>({
    api: '/api/user/bandingUserEmail',
    method: 'post',
    data
  });
}

// 校验绑定邮箱
export function checkEmail(data: {
  account?: string;
  code: string;
  email: string;
  type: number; // 1：登录验证码，4：换绑邮箱,5:绑定邮箱
}) {
  return request<{
    token: string;
  }>({
    api: '/user/verifyEmailCode',
    method: 'post',
    data
  });
}

// 邮箱换绑
export function changeUserEmail(data: {
  newEmail: string;
  newCode: string;
  originEmail?: string;
  originCode?: string;
  uniqueId: string;
}) {
  return request<{
    token: string;
  }>({
    api: '/api/user/changeUserEmail',
    method: 'post',
    data
  });
}